import { LivePreviewNavigation } from "./LivePreviewNavigation";

interface LivePreviewSidebarProps {
    activeTemplateId: string | null;
    setActiveTemplateId: (id: string | null) => void;
}

export const LivePreviewSidebar = ({
    activeTemplateId,
    setActiveTemplateId,
}: LivePreviewSidebarProps) => {
    return (
        <div className="flex h-full flex-col overflow-hidden bg-white">
            <nav className="flex-1 overflow-y-auto px-4">
                <LivePreviewNavigation
                    activeTemplateId={activeTemplateId}
                    setActiveTemplateId={setActiveTemplateId}
                />
            </nav>
        </div>
    );
};
